package com.schoolconnect.app.repository.imports

import com.schoolconnect.app.datasource.network.KtorApiClient
import com.schoolconnect.app.datasource.network.response.BulkUploadResponse
import com.schoolconnect.app.datasource.network.response.BulkUploadValidationResponse
import com.schoolconnect.app.datasource.network.response.StudentEnrollmentBulkResponse
import com.schoolconnect.app.datasource.network.response.StudentEnrollmentValidationResponse

object BulkImportRepository {
    suspend fun downloadSchoolSetupTemplate(schoolCode: String? = null): Result<ByteArray> =
        KtorApiClient.downloadSchoolSetupTemplate(schoolCode?.trim()?.takeIf { it.isNotBlank() })

    suspend fun uploadSchoolSetup(schoolCode: String, fileName: String, bytes: ByteArray, currentUserId: String?): Result<BulkUploadResponse> {
        val normalizedSchoolCode = schoolCode.trim()
        require(normalizedSchoolCode.isNotBlank()) { "schoolCode must not be blank" }
        return KtorApiClient.uploadSchoolSetup(normalizedSchoolCode, fileName.trim(), bytes, currentUserId?.trim())
    }

    suspend fun validateSchoolSetup(schoolCode: String, fileName: String, bytes: ByteArray, currentUserId: String?): Result<BulkUploadValidationResponse> {
        val normalizedSchoolCode = schoolCode.trim()
        require(normalizedSchoolCode.isNotBlank()) { "schoolCode must not be blank" }
        return KtorApiClient.validateSchoolSetup(normalizedSchoolCode, fileName.trim(), bytes, currentUserId?.trim())
    }

    suspend fun downloadStudentEnrollmentTemplate(schoolCode: String? = null): Result<ByteArray> =
        KtorApiClient.downloadStudentEnrollmentTemplate(schoolCode?.trim()?.takeIf { it.isNotBlank() })

    suspend fun uploadStudentEnrollment(schoolCode: String, fileName: String, bytes: ByteArray, currentUserId: String?): Result<StudentEnrollmentBulkResponse> {
        val normalizedSchoolCode = schoolCode.trim()
        require(normalizedSchoolCode.isNotBlank()) { "schoolCode must not be blank" }
        return KtorApiClient.uploadStudentEnrollment(normalizedSchoolCode, fileName.trim(), bytes, currentUserId?.trim(), mode = "save")
    }

    suspend fun validateStudentEnrollment(schoolCode: String, fileName: String, bytes: ByteArray, currentUserId: String?): Result<StudentEnrollmentValidationResponse> {
        val normalizedSchoolCode = schoolCode.trim()
        require(normalizedSchoolCode.isNotBlank()) { "schoolCode must not be blank" }
        return KtorApiClient.validateStudentEnrollment(normalizedSchoolCode, fileName.trim(), bytes, currentUserId?.trim())
    }
}
